import { Badge } from '@chakra-ui/react'
import { PillWithDetail, PillInfoAffix } from './PillWithDetail'

interface FoodTraitBadgeProps {
  icon?: string
  label: string
  bg?: string
  color?: string
}

/**
 * Flattened badge component for food traits.
 * Uses Badge's native flexbox instead of nested HStack/Text wrappers.
 * When `label` carries a parenthetical detail, the pill becomes a tap
 * target that reveals it in a Popover (see PillWithDetail).
 */
export function FoodTraitBadge({
  icon,
  label: rawLabel,
  bg = 'purple.500',
  color = 'white'
}: FoodTraitBadgeProps) {
  // Check if bg is a gradient (starts with 'linear-gradient')
  const isGradient = bg.startsWith('linear-gradient')

  return (
    <PillWithDetail rawLabel={rawLabel}>
      {(label, hasDetail) => (
        <Badge
          bg={isGradient ? undefined : bg}
          bgGradient={isGradient ? bg : undefined}
          color={color}
          display="flex"
          alignItems="center"
          gap={2}
          px={3}
          py={1}
          borderRadius="full"
          fontSize="md"
          fontWeight="medium"
          textTransform="capitalize"
          maxW="100%"
          whiteSpace="normal"
          wordBreak="break-word"
          boxShadow="0 2px 4px var(--color-overlay-20)"
          textShadow="0 1px 2px var(--color-overlay-70)"
        >
          {icon && <span style={{ fontSize: '1.125rem' }}>{icon}</span>}
          {label}
          {hasDetail && <PillInfoAffix />}
        </Badge>
      )}
    </PillWithDetail>

  )
}
